import CompanyResourceLimitationPeriodsList from '@/components/Companies/Settings/CompanyResourceLimitationPeriods/CompanyResourceLimitationPeriodsList';
import { PageProps } from '@/types/PageProps';
import { Typography, Tabs } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import CompanyResourceAvaiable from './CompanyResourceAvaiablePeriods';
import { useHistory } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { isAppPortocar } from '@/index';

export default function CompanyResourceLimitationPeriodsPage({
  route,
}: PageProps) {
  const intl = useIntl();

  const history = useHistory();

  const searchParams = useMemo(
    () => new URLSearchParams(history.location.search),
    [history.location.search],
  );

  const [tab, setTab] = useState<string>();

  useEffect(() => {
    if (searchParams.has('tab')) {
      setTab(searchParams.get('tab') || undefined);
    }
  }, [searchParams]);

  const hasAvailabilityViewPermission =
    hasPermissions([Authorities.COMPANY_AVAILABILITY_VIEW]) && isAppPortocar;

  const hasResourceLimitationPeriodsPermission = hasPermissions([
    Authorities.RESOURCE_LIMITATION_PERIODS_VIEW,
  ]);

  const hasBothPermissions =
    hasAvailabilityViewPermission && hasResourceLimitationPeriodsPermission;

  const tabItems = [
    {
      label: 'Dias da semana habilitado',
      key: 'avaiable',
      children: <CompanyResourceAvaiable />,
      disabled: !hasAvailabilityViewPermission,
    },
    {
      label: 'Dias indisponível',
      key: 'limitation',
      children: <CompanyResourceLimitationPeriodsList />,
      disabled: !hasResourceLimitationPeriodsPermission,
    },
  ];

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <div className="page">
        <div className="page-header" style={{ marginBottom: '24px' }}>
          <Typography.Title level={3}>
            {intl.formatMessage({
              id: 'layout.menu.registry.companies.settings.scheduling-config',
            })}
          </Typography.Title>
        </div>

        <Tabs
          items={
            hasBothPermissions
              ? tabItems
              : hasAvailabilityViewPermission
              ? [tabItems[0]]
              : hasResourceLimitationPeriodsPermission
              ? [tabItems[1]]
              : []
          }
          activeKey={
            tab ||
            (hasBothPermissions || hasAvailabilityViewPermission
              ? 'avaiable'
              : 'limitation')
          }
          onChange={setTab}
        />
      </div>
    </>
  );
}
